// src/utils/queryBuilderServer.ts
// Admin SDK query builder for server environments

import type { QuerySpec } from '@/types/FirestoreQuery'
import type * as admin from 'firebase-admin'

/** Build an Admin SDK Query from a QuerySpec (supports .explain()) */
export function buildServerQuery<T>(
  db: admin.firestore.Firestore,
  spec: QuerySpec<T>,
): admin.firestore.Query {
  const { collection: coll, wheres = [], orders = [], limit: limitCount, cursors = [] } = spec

  let q: admin.firestore.Query = db.collection(coll)

  for (const w of wheres) {
    q = q.where(w.field, w.op as admin.firestore.WhereFilterOp, w.value)
  }
  for (const o of orders) {
    q = q.orderBy(o.field, o.dir as admin.firestore.OrderByDirection)
  }
  for (const c of cursors) {
    if (c.type === 'startAt') q = q.startAt(...c.values)
    if (c.type === 'startAfter') q = q.startAfter(...c.values)
    if (c.type === 'endAt') q = q.endAt(...c.values)
    if (c.type === 'endBefore') q = q.endBefore(...c.values)
  }
  if (limitCount) q = q.limit(limitCount)

  return q
}
